export default __webpack_public_path__ + "assets/logos-partners/govuk/a277922a0701146eebcd83e90ef443d8.png";